import { ListGroup, DrawerItem } from "@gisce/oficina-virtual-components"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom";
import {
  AccountCircle,
	Email
} from "@mui/icons-material";
import { GroupedSideBar } from "./GroupedSideBar";
import useNewsletterPage from "@/components/Newsletter/useNewsletterPage";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";

export const MainDrawerItems = () => {
  const Settings = useSettingsContext();
  const { t } = useTranslation();
  const location = useLocation();
  const { navigateManageNewsletters } = useNewsletterPage();

  const ProfileListGroup = Settings?.newsletter?.enabled && <ListGroup
    icon={<AccountCircle />}
    titleLabel={t('common:text.my_profile_title')}
    startOpen={[t('common:url.changePassword'), t('common:url.newsletter')].includes(location.pathname)}
  >
		{Settings?.newsletter?.enabled && <DrawerItem 
			icon={<Email />}
			label={t('common:text.newsletter_manage')}
			onClick={() => navigateManageNewsletters()}
      selected={location.pathname == t('common:url.newsletter')}
		/>}
  </ListGroup>

  return <>
    {Settings.sidebar?.groups && <GroupedSideBar />}

    {ProfileListGroup}
  </>
}